import React from 'react';
import './css/TermsOfService.css'; // Optional: Link external styling if needed

const TermsOfService = () => {
  return (
    <section className="tos-section">
      <h1>Terms of Service for Lifoura</h1>
      <p><strong>Effective Date</strong>: June 27, 2025</p>

      <p>
        Welcome to <strong>Lifoura</strong> ("we", "our", or "us"). By accessing or using our website 
        <strong> www.lifoura.com </strong> and its related services (collectively, the "Service"), 
        you agree to be bound by these Terms of Service ("Terms"). If you do not agree with any part of 
        these Terms, please do not use Lifoura.
      </p>

      <hr />

      <h2>1. Overview</h2>
      <p>
        Lifoura is a personal media platform that allows users to securely store and organize their life 
        memories (images and videos) — from <em>birth to death</em>. These Terms govern your use of all 
        features and services offered through Lifoura.
      </p>

      <h2>2. Eligibility</h2>
      <ul>
        <li>You must be at least 13 years old.</li>
        <li>You must provide accurate information during registration.</li>
        <li>If using Lifoura on behalf of someone else (e.g., a child or elder), you must have legal authority to do so.</li>
      </ul>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li>Use the platform for lawful and personal purposes only.</li>
        <li>Do not upload content that is illegal, offensive, or violates others' rights.</li>
        <li>Do not share your account or login credentials with others.</li>
        <li>Back up your important media content independently.</li>
      </ul>

      <h2>4. Media Content and Ownership</h2>
      <ul>
        <li>You retain ownership of all media (photos, videos) you upload.</li>
        <li>By uploading content, you grant Lifoura a limited, non-exclusive license to store and display your content only for service purposes.</li>
        <li>Lifoura does not use your content for commercial purposes.</li>
      </ul>

      <h2>5. Account Termination</h2>
      <ul>
        <li>We may suspend or terminate accounts that violate these Terms.</li>
        <li>Inactive accounts may be deleted after 24 months, with notice.</li>
        <li>You may delete your account anytime by contacting us at <strong>support@lifoura.com</strong>.</li>
      </ul>

      <h2>6. Prohibited Content</h2>
      <p>You may <strong>not</strong> upload or share content that:</p>
      <ul>
        <li>Contains nudity or explicit material</li>
        <li>Promotes violence, hate, or harassment</li>
        <li>Violates copyrights or intellectual property</li>
        <li>Is misleading, harmful, or fraudulent</li>
      </ul>

      <h2>7. Privacy and Security</h2>
      <p>
        Your privacy matters to us. See our <a href="/privacy">Privacy Policy</a> for details. 
        We use modern encryption and secure protocols, but cannot guarantee absolute security.
      </p>

      <h2>8. Changes to the Service</h2>
      <p>We may update, modify, or discontinue parts of the Service. Users will be notified of any major changes.</p>

      <h2>9. Disclaimer of Warranty</h2>
      <p>
        The Service is provided "as is" and "as available" with no warranties. 
        We do not guarantee uninterrupted access or error-free experience.
      </p>

      <h2>10. Limitation of Liability</h2>
      <ul>
        <li>Lifoura is not liable for any indirect, incidental, or consequential damages.</li>
        <li>Total liability is limited to any amount paid by you (if any).</li>
      </ul>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of <strong>India</strong>. All disputes will be 
        subject to the jurisdiction of the courts in <strong>Surat, Gujarat</strong>.
      </p>

      <h2>12. Contact Us</h2>
      <p>If you have questions, contact us at:</p>
      <p>
        <strong>Email</strong>: support@lifoura.com<br />
        <strong>Website</strong>: <a href="https://www.lifoura.com">www.lifoura.com</a>
      </p>
    </section>
  );
};

export default TermsOfService;
